export default {
  'pages.layouts.userLayout.title': 'Hi~',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.workbench.link': 'workbench',
  'pages.workbench.alertMessage':
    'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, workbench to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.batchApproval': 'batch approval',
  'pages.customerIntelligence.customerList.columns.name': 'Customer Name',
  'pages.customerIntelligence.customerList.columns.owner': 'Owner',
  'pages.customerIntelligence.customerList.columns.mobile': 'Mobile',
  'pages.customerIntelligence.customerList.columns.email': 'Email',
  'pages.customerIntelligence.customerList.columns.followUpStatus':
    'Follow-up Status',
  'pages.customerIntelligence.customerList.columns.lockStatus': 'Locked',
  'pages.customerIntelligence.customerList.columns.dealStatus': 'Won',
  'pages.customerIntelligence.customerList.columns.contactLastTime':
    'Last Contact Time',
  'pages.customerIntelligence.customerList.columns.contactNextTime':
    'Next Contact Time',
  'pages.customerIntelligence.customerList.search.keyword': 'Keyword',
  'pages.customerIntelligence.customerList.placeholder.empty': '-',
  'pages.customerIntelligence.customerList.empty': 'No customer data',
  'pages.customerIntelligence.customerList.boolean.yes': 'Yes',
  'pages.customerIntelligence.customerList.boolean.no': 'No',
  'pages.customerIntelligence.customerList.create.button': 'Create Customer',
  'pages.customerIntelligence.customerList.create.modalTitle':
    'Create Customer',
  'pages.customerIntelligence.customerList.create.success': 'Customer created',
  'pages.customerIntelligence.customerList.create.form.name': 'Customer Name',
  'pages.customerIntelligence.customerList.create.form.name.required':
    'Please enter customer name',
  'pages.customerIntelligence.customerList.create.form.name.placeholder':
    'Enter customer name',
  'pages.customerIntelligence.customerList.create.form.mobile': 'Mobile',
  'pages.customerIntelligence.customerList.create.form.telephone': 'Telephone',
  'pages.customerIntelligence.customerList.create.form.email': 'Email',
  'pages.customerIntelligence.customerList.create.form.qq': 'QQ',
  'pages.customerIntelligence.customerList.create.form.wechat': 'WeChat',
  'pages.customerIntelligence.customerList.create.form.remark': 'Remark',
  'pages.customerIntelligence.customerList.alert.missingTenant':
    'Tenant context is missing, so the result may be incomplete.',
  'pages.customerIntelligence.customerList.alert.missingMember':
    'The current session is missing memberUuid, so "My Customers" cannot be queried.',
  'pages.zyConsultantOperations.diagnosisSessions.columns.customerName':
    'Customer Name',
  'pages.zyConsultantOperations.diagnosisSessions.columns.title': 'Title',
  'pages.zyConsultantOperations.diagnosisSessions.columns.diagnosisDate':
    'Diagnosis Date',
  'pages.zyConsultantOperations.diagnosisSessions.columns.industry': 'Industry',
  'pages.zyConsultantOperations.diagnosisSessions.columns.intervieweeRole':
    'Interviewee',
  'pages.zyConsultantOperations.diagnosisSessions.columns.status': 'Status',
  'pages.zyConsultantOperations.diagnosisSessions.columns.overallRiskLevel':
    'Overall Risk',
  'pages.zyConsultantOperations.diagnosisSessions.columns.actions': 'Actions',
  'pages.zyConsultantOperations.diagnosisSessions.actions.detail': 'Detail',
  'pages.zyConsultantOperations.diagnosisSessions.actions.run': 'Run',
  'pages.zyConsultantOperations.diagnosisSessions.actions.result': 'Result',
  'pages.zyConsultantOperations.diagnosisSessions.search.placeholder':
    'Search title/customer/industry',
  'pages.zyConsultantOperations.diagnosisSessions.search.statusPlaceholder':
    'Status',
  'pages.zyConsultantOperations.diagnosisSessions.create.button':
    'Create Session',
  'pages.zyConsultantOperations.diagnosisSessions.create.modalTitle':
    'Create Diagnosis Session',
  'pages.zyConsultantOperations.diagnosisSessions.create.success':
    'Diagnosis session created',
  'pages.zyConsultantOperations.diagnosisSessions.form.pack': 'Question Pack',
  'pages.zyConsultantOperations.diagnosisSessions.form.customer': 'Customer',
  'pages.zyConsultantOperations.diagnosisSessions.form.customerPlaceholder':
    'Search and select my customer',
  'pages.zyConsultantOperations.diagnosisSessions.form.customerLoadFailed':
    'Failed to load customer list',
  'pages.zyConsultantOperations.diagnosisSessions.form.missingMember':
    'Current session is missing memberUuid, so "My Customers" cannot be loaded.',
  'pages.zyConsultantOperations.diagnosisSessions.form.titleSuggestionFailed':
    'Failed to generate title suggestion',
  'pages.zyConsultantOperations.diagnosisSessions.form.customerName':
    'Customer Name',
  'pages.zyConsultantOperations.diagnosisSessions.form.title': 'Title',
  'pages.zyConsultantOperations.diagnosisSessions.form.titlePlaceholder':
    'Auto-generated from customer and editable',
  'pages.zyConsultantOperations.diagnosisSessions.form.diagnosisDate':
    'Diagnosis Date',
  'pages.zyConsultantOperations.diagnosisSessions.form.industry': 'Industry',
  'pages.zyConsultantOperations.diagnosisSessions.form.intervieweeRole':
    'Interviewee Role',
  'pages.zyConsultantOperations.diagnosisSessions.form.sourceChannel':
    'Source Channel',
  'pages.zyConsultantOperations.diagnosisSessions.form.required':
    'This field is required',
  'pages.zyConsultantOperations.diagnosisSessions.status.draft': 'Draft',
  'pages.zyConsultantOperations.diagnosisSessions.status.inProgress':
    'In Progress',
  'pages.zyConsultantOperations.diagnosisSessions.status.completed':
    'Completed',
  'pages.zyConsultantOperations.diagnosisRun.loading': 'Loading...',
  'pages.zyConsultantOperations.diagnosisRun.titlePrefix': 'Run Diagnosis',
  'pages.zyConsultantOperations.diagnosisRun.boolean.yes': 'Yes',
  'pages.zyConsultantOperations.diagnosisRun.boolean.no': 'No',
  'pages.zyConsultantOperations.diagnosisRun.field.evidenceSummary':
    'Evidence Summary',
  'pages.zyConsultantOperations.diagnosisRun.field.note': 'Consultant Note',
  'pages.zyConsultantOperations.diagnosisRun.action.save': 'Save Answers',
  'pages.zyConsultantOperations.diagnosisRun.action.finish': 'Finish Diagnosis',
  'pages.zyConsultantOperations.diagnosisRun.message.answersSaved':
    'Answers saved',
  'pages.zyConsultantOperations.diagnosisRun.message.finished':
    'Diagnosis completed',
  'pages.zyConsultantOperations.diagnosisResult.loading': 'Loading...',
  'pages.zyConsultantOperations.diagnosisResult.cardTitle': 'Diagnosis Result',
  'pages.zyConsultantOperations.diagnosisResult.card.overallRisk':
    'Overall Risk',
  'pages.zyConsultantOperations.diagnosisResult.card.highRisk': 'High Risk',
  'pages.zyConsultantOperations.diagnosisResult.card.mediumRisk': 'Medium Risk',
  'pages.zyConsultantOperations.diagnosisResult.card.lowRisk': 'Low Risk',
  'pages.zyConsultantOperations.diagnosisResult.section.dimensionScores':
    'Dimension Scores',
  'pages.zyConsultantOperations.diagnosisResult.section.highlightedQuestions':
    'Highlighted Questions',
  'pages.zyConsultantOperations.diagnosisResult.section.suggestionDirections':
    'Suggestion Directions',
  'pages.zyConsultantOperations.diagnosisResult.column.frameworkType':
    'Framework',
  'pages.zyConsultantOperations.diagnosisResult.column.level1': 'Level 1',
  'pages.zyConsultantOperations.diagnosisResult.column.level2': 'Level 2',
  'pages.zyConsultantOperations.diagnosisResult.column.averageScore':
    'Average Score',
  'pages.zyConsultantOperations.diagnosisResult.column.answeredCount':
    'Answered Count',
  'pages.zyConsultantOperations.diagnosisResult.column.questionTitle':
    'Question',
  'pages.zyConsultantOperations.diagnosisResult.column.riskLevel': 'Risk',
  'pages.zyConsultantOperations.diagnosisResult.column.causeType': 'Cause',
  'pages.zyConsultantOperations.diagnosisResult.column.solutionDirection':
    'Solution Direction',
  'pages.zyConsultantOperations.diagnosisResult.column.answer': 'Answer',
  'pages.zyConsultantOperations.diagnosisDetail.loading': 'Loading...',
  'pages.zyConsultantOperations.diagnosisDetail.invalidUuid':
    'Missing diagnosis session uuid.',
  'pages.zyConsultantOperations.diagnosisDetail.titleFallback':
    'Diagnosis Session',
  'pages.zyConsultantOperations.diagnosisDetail.tab.basic': 'Basic Info',
  'pages.zyConsultantOperations.diagnosisDetail.tab.questions': 'Question Pack',
  'pages.zyConsultantOperations.diagnosisDetail.tab.analysis': 'Statistics',
  'pages.zyConsultantOperations.diagnosisDetail.field.createdAt': 'Created At',
  'pages.zyConsultantOperations.diagnosisDetail.field.startedAt': 'Started At',
  'pages.zyConsultantOperations.diagnosisDetail.field.completedAt':
    'Completed At',
  'pages.zyConsultantOperations.diagnosisDetail.message.started':
    'Diagnosis session started',
  'pages.zyConsultantOperations.diagnosisDetail.questions.notStarted':
    'This session has not started yet.',
  'pages.zyConsultantOperations.diagnosisDetail.questions.start':
    'Start and Answer',
  'pages.zyConsultantOperations.diagnosisDetail.questions.empty':
    'No questions found in this diagnosis session.',
  'pages.zyConsultantOperations.diagnosisDetail.analysis.empty':
    'No analysis data yet. Please answer and save questions first.',
  'pages.zyConsultantOperations.settings.tab.codeRules': 'Code Rules',
  'pages.zyConsultantOperations.settings.tab.dict': 'Dictionary',
  'pages.zyConsultantOperations.settings.tab.taxonomy': 'Tag Management',
  'pages.zyConsultantOperations.settings.dict.types': 'Dictionary Types',
  'pages.zyConsultantOperations.settings.dict.items': 'Dictionary Items',
  'pages.zyConsultantOperations.settings.dict.questionCategory':
    'Question Category',
  'pages.zyConsultantOperations.settings.taxonomy.list': 'Taxonomy List',
  'pages.zyConsultantOperations.settings.taxonomy.tree': 'Tag Tree',
  'pages.zyConsultantOperations.settings.taxonomy.aiWorkbench':
    'AI Tag Builder',
  'pages.zyConsultantOperations.settings.taxonomy.generateOptions':
    'Generation settings',
  'pages.zyConsultantOperations.settings.taxonomy.preview': 'Preview',
  'pages.zyConsultantOperations.settings.taxonomy.previewHint':
    'Select the tags you want to add to the tree',
  'pages.zyConsultantOperations.settings.taxonomy.target': 'Target location',
  'pages.zyConsultantOperations.settings.taxonomy.targetChild':
    'Create as child tags',
  'pages.zyConsultantOperations.settings.taxonomy.targetRoot':
    'Create as root tags',
  'pages.zyConsultantOperations.settings.taxonomy.rootTarget':
    'Current taxonomy root',
  'pages.zyConsultantOperations.settings.taxonomy.targetHint':
    'Select a tag in the tree to place all candidates under that node.',
  'pages.zyConsultantOperations.settings.taxonomy.mode': 'Decomposition mode',
  'pages.zyConsultantOperations.settings.taxonomy.modeSmart': 'Smart expansion',
  'pages.zyConsultantOperations.settings.taxonomy.modeCount':
    'Generate a fixed count',
  'pages.zyConsultantOperations.settings.taxonomy.modeManual':
    'Manual input (one per line)',
  'pages.zyConsultantOperations.settings.taxonomy.subject': 'Topic',
  'pages.zyConsultantOperations.settings.taxonomy.subjectPlaceholder':
    'For example: collaboration, data governance, business analysis',
  'pages.zyConsultantOperations.settings.taxonomy.subjectPlaceholderSelected':
    'The selected tag is already used as context; add a narrower topic if needed',
  'pages.zyConsultantOperations.settings.taxonomy.targetCount': 'Target count',
  'pages.zyConsultantOperations.settings.taxonomy.manualInput': 'Manual input',
  'pages.zyConsultantOperations.settings.taxonomy.manualInputPlaceholder':
    'One draft tag per line, for example:\nProcess collaboration\nMetric alignment\nReview cadence',
  'pages.zyConsultantOperations.settings.taxonomy.prompt': 'Prompt guidance',
  'pages.zyConsultantOperations.settings.taxonomy.promptPlaceholder':
    'For example: use consulting language, avoid duplicates, prioritize org and process',
  'pages.zyConsultantOperations.settings.taxonomy.aiMeta':
    'Generated with model',
  'pages.zyConsultantOperations.settings.taxonomy.reason': 'Rationale',
  'pages.zyConsultantOperations.settings.taxonomy.emptyCandidates':
    'Choose a mode and generate candidates before creating them in bulk.',
  'pages.zyConsultantOperations.settings.column.code': 'Code',
  'pages.zyConsultantOperations.settings.column.name': 'Name',
  'pages.zyConsultantOperations.settings.column.description': 'Description',
  'pages.zyConsultantOperations.settings.column.value': 'Value',
  'pages.zyConsultantOperations.settings.column.sortOrder': 'Sort',
  'pages.zyConsultantOperations.settings.column.enabled': 'Enabled',
  'pages.zyConsultantOperations.settings.column.actions': 'Actions',
  'pages.zyConsultantOperations.settings.action.edit': 'Edit',
  'pages.zyConsultantOperations.settings.action.delete': 'Delete',
  'pages.zyConsultantOperations.settings.action.refresh': 'Refresh',
  'pages.zyConsultantOperations.settings.action.moveTop': 'Move to first',
  'pages.zyConsultantOperations.settings.action.moveUp': 'Move Up',
  'pages.zyConsultantOperations.settings.action.moveDown': 'Move Down',
  'pages.zyConsultantOperations.settings.action.moveBottom': 'Move to last',
  'pages.zyConsultantOperations.settings.action.addCategory': 'Add Category',
  'pages.zyConsultantOperations.settings.action.addChildCategory': 'Add Child',
  'pages.zyConsultantOperations.settings.action.addDictItem': 'Add Item',
  'pages.zyConsultantOperations.settings.action.addDictType': 'Add Type',
  'pages.zyConsultantOperations.settings.action.addTaxonomy': 'Add Taxonomy',
  'pages.zyConsultantOperations.settings.action.initEnterprisePortraitTaxonomies':
    'Initialize Portrait Taxonomies',
  'pages.zyConsultantOperations.settings.action.addSiblingTag':
    'Add Sibling Tag',
  'pages.zyConsultantOperations.settings.action.addRootTag': 'Add Root Tag',
  'pages.zyConsultantOperations.settings.action.addChildTag': 'Add Child Tag',
  'pages.zyConsultantOperations.settings.action.openAiModal': 'AI Tag Builder',
  'pages.zyConsultantOperations.settings.action.clearTarget': 'Target root',
  'pages.zyConsultantOperations.settings.action.clearCandidates':
    'Clear candidates',
  'pages.zyConsultantOperations.settings.action.createSelectedCandidates':
    'Create selected',
  'pages.zyConsultantOperations.settings.action.generateCandidates':
    'Generate candidates',
  'pages.zyConsultantOperations.settings.action.resetPrompt': 'Clear inputs',
  'pages.zyConsultantOperations.settings.action.cancel': 'Cancel',
  'pages.zyConsultantOperations.settings.modal.editDictItem':
    'Edit Dictionary Item',
  'pages.zyConsultantOperations.settings.modal.addDictType':
    'Add Dictionary Type',
  'pages.zyConsultantOperations.settings.modal.addDictItem':
    'Add Dictionary Item',
  'pages.zyConsultantOperations.settings.message.dictItemUpdated':
    'Dictionary item updated',
  'pages.zyConsultantOperations.settings.message.dictItemCreated':
    'Dictionary item created',
  'pages.zyConsultantOperations.settings.message.dictItemDeleted':
    'Dictionary item deleted',
  'pages.zyConsultantOperations.settings.message.categoryUpdated':
    'Category updated',
  'pages.zyConsultantOperations.settings.message.categoryCreated':
    'Category created',
  'pages.zyConsultantOperations.settings.message.taxonomyUpdated':
    'Taxonomy updated',
  'pages.zyConsultantOperations.settings.message.taxonomyCreated':
    'Taxonomy created',
  'pages.zyConsultantOperations.settings.message.taxonomyDeleted':
    'Taxonomy deleted',
  'pages.zyConsultantOperations.settings.message.enterprisePortraitTaxonomiesInitialized':
    'Enterprise portrait taxonomies initialized',
  'pages.zyConsultantOperations.settings.message.enterprisePortraitTaxonomiesCreated':
    'Created taxonomies',
  'pages.zyConsultantOperations.settings.message.enterprisePortraitTagsCreated':
    'Created tags',
  'pages.zyConsultantOperations.settings.message.enterprisePortraitTaxonomiesSkipped':
    'Skipped taxonomies',
  'pages.zyConsultantOperations.settings.message.enterprisePortraitTagsSkipped':
    'Skipped tags',
  'pages.zyConsultantOperations.settings.message.tagUpdated': 'Tag updated',
  'pages.zyConsultantOperations.settings.message.tagCreated': 'Tag created',
  'pages.zyConsultantOperations.settings.message.tagDeleted': 'Tag deleted',
  'pages.zyConsultantOperations.settings.message.selectTaxonomyFirst':
    'Select a taxonomy first',
  'pages.zyConsultantOperations.settings.message.aiCandidatesReady':
    'Candidates generated',
  'pages.zyConsultantOperations.settings.message.selectCandidateFirst':
    'Select at least one candidate tag',
  'pages.zyConsultantOperations.settings.message.aiCreatePartial':
    'Candidate creation finished',
  'pages.zyConsultantOperations.settings.message.aiCreateSuccess':
    'Selected candidates created',
  'pages.fieldResearch.records.title': 'Field Research Records',
  'pages.fieldResearch.records.search.placeholder':
    'Search by customer or title',
  'pages.fieldResearch.records.search.status': 'Status',
  'pages.fieldResearch.records.create': 'New Record',
  'pages.fieldResearch.records.columns.title': 'Title',
  'pages.fieldResearch.records.columns.customer': 'Customer',
  'pages.fieldResearch.records.columns.researchDate': 'Research Date',
  'pages.fieldResearch.records.columns.status': 'Status',
  'pages.fieldResearch.records.columns.updatedAt': 'Updated At',
  'pages.fieldResearch.records.columns.actions': 'Actions',
  'pages.fieldResearch.records.actions.continue': 'Continue',
  'pages.fieldResearch.records.actions.view': 'Open Panel',
  'pages.fieldResearch.records.form.customer': 'Customer',
  'pages.fieldResearch.records.form.customerPlaceholder': 'Select customer',
  'pages.fieldResearch.records.form.title': 'Title',
  'pages.fieldResearch.records.form.titlePlaceholder':
    'Optional, auto-generated by default',
  'pages.fieldResearch.records.form.researchDate': 'Research Date',
  'pages.fieldResearch.records.status.draft': 'Draft',
  'pages.fieldResearch.records.status.inProgress': 'In Progress',
  'pages.fieldResearch.records.status.completed': 'Completed',
  'pages.fieldResearch.records.status.archived': 'Archived',
  'pages.fieldResearch.panel.loading': 'Loading panel...',
  'pages.fieldResearch.panel.left.customer': 'Customer Info',
  'pages.fieldResearch.panel.left.questions': 'Question Search',
  'pages.fieldResearch.panel.left.tasks': 'Tasks',
  'pages.fieldResearch.panel.left.tab.question': 'Search Questions',
  'pages.fieldResearch.panel.left.tab.tag': 'Search Tags',
  'pages.fieldResearch.panel.left.searchPlaceholder':
    'Search by question title or ask text',
  'pages.fieldResearch.panel.left.tagSearchPlaceholder':
    'Search tags first, then view related questions',
  'pages.fieldResearch.panel.left.tagRelatedQuestions': 'Related Questions',
  'pages.fieldResearch.panel.left.tagSelectHint':
    'Select a tag to view related questions',
  'pages.fieldResearch.panel.left.tagEmpty': 'No matching tags',
  'pages.fieldResearch.panel.left.tagQuestionEmpty':
    'No questions found under this tag',
  'pages.fieldResearch.panel.left.detail': 'View Details',
  'pages.fieldResearch.panel.left.addToInterview': 'Add to Interview',
  'pages.fieldResearch.panel.middle.records': 'Interview Records',
  'pages.fieldResearch.panel.middle.addFree': 'Add Free Note',
  'pages.fieldResearch.panel.middle.save': 'Save',
  'pages.fieldResearch.panel.middle.autoSaved': 'Auto-saved',
  'pages.fieldResearch.panel.middle.localDraft':
    'Network unstable, stored in local draft',
  'pages.fieldResearch.panel.right.ai': 'AI Chat',
  'pages.fieldResearch.panel.right.related': 'Related Knowledge',
  'pages.fieldResearch.panel.right.relatedSearchPlaceholder':
    'Search items in this section',
  'pages.fieldResearch.panel.right.relatedPin': 'Pin',
  'pages.fieldResearch.panel.right.relatedPinned': 'Pinned',
  'pages.fieldResearch.panel.right.askPlaceholder':
    'Ask anything, AI will answer with suggestions and references',
  'pages.fieldResearch.panel.right.send': 'Send',
  'pages.fieldResearch.panel.action.complete': 'Complete Session',
  'pages.fieldResearch.panel.entry.type.question': 'Question Note',
  'pages.fieldResearch.panel.entry.type.free': 'Free Note',
  'pages.fieldResearch.panel.entry.content': 'Content',
  'pages.fieldResearch.panel.entry.evidence': 'Evidence',
  'pages.fieldResearch.panel.entry.signals': 'Signals (comma separated)',
  'pages.fieldResearch.panel.entry.remove': 'Delete',
  'pages.fieldResearch.panel.entry.title': 'Record Title',
  'pages.fieldResearch.panel.entry.save': 'Save',
};
